const FETCH_LTV_DETAIL = 'adebify-ltv-detail/FETCH_LTV_DETAIL';
const FETCH_LTV_DETAIL_SUCCEEDED = 'adebify-ltv-detail/FETCH_LTV_DETAIL_SUCCEEDED';
const FETCH_LTV_DETAIL_FAILED = 'adebify-ltv-detail/FETCH_LTV_DETAIL_FAILED';
const REQUEST_START = 'adebify-ltv-detail/REQUEST_START';

const SET_LTV_EVALUATION_PERIOD = 'adebify-ltv-detail/SET_LTV_EVALUATION_PERIOD';
const UPDATE_SORT = 'adebify-ltv-detail/UPDATE_SORT';
const UPDATE_PAGE = 'adebify-ltv-detail/UPDATE_PAGE';
const SET_AXIS = 'adebify-ltv-detail/SET_AXIS';
const SET_PRODUCT_AXIS = 'adebify-ltv-detail/SET_PRODUCT_AXIS';
const SET_DIMENSIONS = 'adebify-ltv-detail/SET_DIMENSIONS';
const SET_METRICS = 'adebify-ltv-detail/SET_METRICS';
const SET_FILTERS = 'adebify-ltv-detail/SET_FILTERS';
// Atomic update for the 項目切替 modal so we only refetch once.
const SET_DISPLAY_ITEMS = 'adebify-ltv-detail/SET_DISPLAY_ITEMS';
// Restore persisted settings without triggering a fetch (container fetches once).
const HYDRATE_DISPLAY_ITEMS = 'adebify-ltv-detail/HYDRATE_DISPLAY_ITEMS';
const DOWNLOAD_CSV = 'adebify-ltv-detail/DOWNLOAD_CSV';

export default {
  FETCH_LTV_DETAIL,
  FETCH_LTV_DETAIL_SUCCEEDED,
  FETCH_LTV_DETAIL_FAILED,
  REQUEST_START,
  SET_LTV_EVALUATION_PERIOD,
  UPDATE_SORT,
  UPDATE_PAGE,
  SET_AXIS,
  SET_PRODUCT_AXIS,
  SET_DIMENSIONS,
  SET_METRICS,
  SET_FILTERS,
  SET_DISPLAY_ITEMS,
  HYDRATE_DISPLAY_ITEMS,
  DOWNLOAD_CSV,
};
